import Entity from './entity'
export default class Equipment extends Entity<number>{
    mac:string;
    status:Number=1;
    ftId:number;
    fId:number;
    wId:number;
    updateThreshold:Number=0;
    updateTempHumi:Number=0;
    updateEqutime:Number=0;
    updateTimer1:Number=0;
    updateTimer2:Number=0;
    updateIanport:Number=0;
    updateWorkMode:Number=0;
    upgrade:Number=0;
    updateRestart:Number=0;
    updateMaxtemp:Number=0;
    updateMaxhumi:Number=0;
}